import { render } from "./LocationManage.vue?vue&type=template&id=25b17dcd"
import script from "./LocationManage.vue?vue&type=script&lang=js"
export * from "./LocationManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__